import { ArrayStorageHookManager } from '@bridebook/toolbox/src/storage-managers';
import { IArticleBase } from '@bridebook/web/app-shared/lib/articles/types';

export const useRecentArticlesStorage = () =>
  ArrayStorageHookManager<IArticleBase>({
    storageKey: 'recently-viewed-articles',
    maxItems: 6,
  }).get({ compareKey: 'ID' });
